import { PlanUpdateSuccess } from "../PlanUpdateSuccess";
import { useUpgradeFlowShellContext } from "../UpgradeFlowContext";

export const UpgradeSuccessfulRoute = () => {
  const { handleOnSuccess, successButtonLabel } = useUpgradeFlowShellContext();

  return (
    <PlanUpdateSuccess
      buttonLabel={successButtonLabel}
      onSuccess={handleOnSuccess}
    />
  );
};
